angular
  .module('pb.base')

  .factory('FormatsCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class FormatsCrud extends Crud {
        constructor(list) {
          super(
            'signup' + (list || ''),
            '@@apiUrl' + '/extensions' + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return FormatsCrud;
    }
  ]);
